
(function() {
  class ProductUpsell extends HTMLElement {
    constructor() {
      super();
      this.productData = new Map();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    connectedCallback() {
      this.loadProductData();
      this.setupEventListeners();
    }

    loadProductData() {
      const variantScripts = this.querySelectorAll('script[data-product-variants]');
      variantScripts.forEach(script => {
        const productId = script.getAttribute('data-product-variants');
        const variants = JSON.parse(script.textContent);
        this.productData.set(productId, variants);
      });
    }
    
    setupEventListeners() {
      this.addEventListener('change', this.handleVariantChange.bind(this));
      this.addEventListener('click', this.handleAddToCart.bind(this));
      
      this.querySelectorAll('.upsell-product').forEach(productEl => {
        this.updateSelectedVariant(productEl);
      });
    }

    handleVariantChange(event) {
      if (event.target.classList.contains('upsell-variant-select')) {
        const productEl = event.target.closest('.upsell-product');
        this.updateSelectedVariant(productEl);
      }
    }

    updateSelectedVariant(productEl) {
      const productId = productEl.getAttribute('data-product-id');
      const variants = this.productData.get(productId);
      const selects = productEl.querySelectorAll('.upsell-variant-select');
      
      if (selects.length === 0) return;

      const selectedOptions = Array.from(selects).map(select => select.value);
      
      const matchingVariant = variants.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });

      const addToCartBtn = productEl.querySelector('.upsell-add-to-cart');
      // const priceEl = productEl.querySelector('[data-price]');
      // const priceE2 = productEl.querySelector('[data-compare-price]');
      
      if (matchingVariant) {
        addToCartBtn.disabled = !matchingVariant.available;
        addToCartBtn.setAttribute('data-variant-id', matchingVariant.id);
        // console.log("matchingVariant",matchingVariant);
        // priceEl.textContent = this.formatMoney(matchingVariant.price);
        // priceE2.textContent = this.formatMoney(matchingVariant.compare_at_price);
        // priceEl.setAttribute('data-price', matchingVariant.price);
        // priceE2.setAttribute('data-compare-price', matchingVariant.compare_at_price);
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.removeAttribute('data-variant-id');}
    }

    async handleAddToCart(event) {
      if (event.target.classList.contains('upsell-add-to-cart')) {
        event.preventDefault();
        
        const button = event.target;
        const productEl = button.closest('.upsell-product');
        const statusEl = productEl.querySelector('.upsell-status');
        
        let variantId = button.getAttribute('data-variant-id');

        // --------------------------------------------
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
    
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
         
            this.cart.setActiveElement(document.activeElement);
        }
        // --------------------------------------
        
        
        if (!variantId) {
            const hiddenInput = productEl.querySelector('input[name="variant_id"]');
            if (hiddenInput) {
                variantId = hiddenInput.value;
            }
        }
        
        if (!variantId) {
            this.showStatus(statusEl, 'Please select all options', 'error');
            return;
        }
        
        formData.append("id", variantId);
        formData.append("quantity", 1);
        config.body = formData;

        button.disabled = true;
        button.textContent = 'Adding...';
        statusEl.textContent = '';

        try {
          const response = await fetch('/cart/add.js',config );

          if (response.ok) {
            const jsonResponse = await response.json();
            this.showStatus(statusEl, 'Added to cart!', 'success');
            this.cart.renderContents(jsonResponse);
          } else {
            const errorData = await response.json();
            this.showStatus(statusEl, errorData.description || 'Error adding to cart', 'error');
          }
        } catch (error) {
          this.showStatus(statusEl, 'Network error', 'error');
          console.log("error", error);
        } finally {
          button.disabled = false;
          button.textContent = 'Add to Cart';
        }
      }
    }

    showStatus(statusEl, message, type) {
      statusEl.textContent = message;
      statusEl.className = `upsell-status upsell-status-${type}`;
      if (type === 'success') {
        setTimeout(() => {
          statusEl.textContent = '';
          statusEl.className = 'upsell-status';
        }, 3000);
      }
    }

    formatMoney(cents) {
      const amount = cents / 100;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amount);
    }
  }

  customElements.define('product-upsell', ProductUpsell);
})();